var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137,
    height: 18.026,
    viewBox: "0 0 137 18.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "5mkk3oq2la"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4",
    style: {
      fill: "none"
    },
    d: "M0 0h24.255v17.337H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8",
    transform: "translate(0 .456)",
    style: {
      clipPath: "url(#5mkk3oq2la)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21",
    d: "M.866 8.668h9.3a3.463 3.463 0 0 0 2.969-1.682l3.435-5.724A2.6 2.6 0 0 1 18.8 0h4.592a.867.867 0 0 1 .866.867V7.8a.867.867 0 0 1-.866.867h-9.3a3.463 3.463 0 0 0-2.971 1.685l-3.428 5.721a2.6 2.6 0 0 1-2.228 1.263H.866A.866.866 0 0 1 0 16.47V9.535a.866.866 0 0 1 .866-.867z",
    style: {
      fill: "#3dcdc2",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22",
    d: "m213.222 12.167 3.378-.216a.215.215 0 0 1 .228.2 3.042 3.042 0 0 0 3.312 2.813c1.66 0 2.831-.83 2.831-2.076 0-1.075-.732-1.734-2.05-1.954l-2.123-.293c-3.758-.513-5.295-2.613-5.295-5.226 0-3.2 2.635-5.4 6.466-5.4 3.528 0 6.287 2.284 6.391 5.3a.217.217 0 0 1-.205.227l-3.456.174a.215.215 0 0 1-.225-.2 2.558 2.558 0 0 0-2.674-2.467c-1.516 0-2.44.806-2.44 2 0 1 .634 1.66 1.829 1.857l2.123.318c3.782.488 5.539 2.637 5.539 5.3 0 3.274-2.782 5.52-6.832 5.52s-6.889-2.3-7-5.656a.214.214 0 0 1 .2-.219z",
    transform: "translate(-181.077 -.02)",
    style: {
      fill: "#080f13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 23",
    d: "M313.81 38.623a6.763 6.763 0 1 1 6.76 6.539 6.551 6.551 0 0 1-6.76-6.539zm9.736 0c0-2.026-1.221-3.392-2.976-3.392s-2.976 1.366-2.976 3.392 1.221 3.392 2.976 3.392 2.976-1.391 2.976-3.392z",
    transform: "translate(-266.755 -27.238)",
    style: {
      fill: "#080f13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24",
    d: "M485.017 39.649h-8.27a.218.218 0 0 0-.216.24 2.62 2.62 0 0 0 2.665 2.444 2.485 2.485 0 0 0 2.468-1.592.216.216 0 0 1 .222-.15l2.866.235a.219.219 0 0 1 .2.252c-.387 2.39-2.726 4.085-5.752 4.085a6.233 6.233 0 0 1-6.466-6.539 6.183 6.183 0 0 1 6.344-6.563c3.734 0 6.223 2.635 6.223 6.418a7.019 7.019 0 0 1-.066.984.219.219 0 0 1-.214.187zm-3.629-2.294a.216.216 0 0 0 .216-.231 2.553 2.553 0 0 0-5.07-.01.215.215 0 0 0 .214.24h4.638z",
    transform: "translate(-401.731 -27.238)",
    style: {
      fill: "#080f13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25",
    d: "m653.288 40.374 2.991-.085a.217.217 0 0 1 .22.193 1.946 1.946 0 0 0 2.182 1.606c1.074 0 1.781-.439 1.781-1.123 0-.732-.537-1.024-1.61-1.2l-1.634-.268c-2.708-.39-3.929-1.684-3.929-3.831 0-2.513 2.123-4.271 5.149-4.271s5.187 1.676 5.38 4.115a.217.217 0 0 1-.211.234l-2.948.064a.214.214 0 0 1-.217-.184 1.919 1.919 0 0 0-2-1.616c-.9 0-1.586.513-1.586 1.221 0 .561.39.927 1.147 1.05l1.66.268c2.9.439 4.416 1.855 4.416 3.978 0 2.465-2.221 4.173-5.392 4.173s-5.449-1.676-5.6-4.1a.217.217 0 0 1 .21-.231z",
    transform: "translate(-554.96 -26.677)",
    style: {
      fill: "#080f13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26",
    d: "M733.79 38.623a6.763 6.763 0 1 1 6.76 6.539 6.551 6.551 0 0 1-6.76-6.539zm9.736 0c0-2.026-1.221-3.392-2.977-3.392s-2.976 1.366-2.976 3.392 1.221 3.392 2.976 3.392 2.977-1.391 2.977-3.392z",
    transform: "translate(-623.49 -27.238)",
    style: {
      fill: "#080f13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 27",
    d: "M570.7 33.72a1.466 1.466 0 0 1 .774-.637 4.043 4.043 0 0 1 1.323-.213c2.782 0 4.636 2 4.636 5.026v7.373a.215.215 0 0 1-.216.216h-3.3a.215.215 0 0 1-.216-.216v-6.812c0-1.634-.805-2.587-2.2-2.587s-2.221 1.024-2.221 2.782v6.616a.215.215 0 0 1-.216.216h-3.3a.215.215 0 0 1-.216-.216V33.33a.215.215 0 0 1 .216-.216h3.294a.216.216 0 0 1 .216.223l-.081 2.506a.108.108 0 0 0 .2.058l1.3-2.182z",
    transform: "translate(-480.593 -27.927)",
    style: {
      fill: "#080f13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 28",
    d: "M837.742 33.72a1.466 1.466 0 0 1 .774-.637 4.043 4.043 0 0 1 1.322-.213c2.782 0 4.636 2 4.636 5.026v7.373a.215.215 0 0 1-.216.216h-3.3a.215.215 0 0 1-.216-.216v-6.812c0-1.634-.805-2.587-2.2-2.587s-2.221 1.024-2.221 2.782v6.616a.215.215 0 0 1-.216.216h-3.3a.215.215 0 0 1-.216-.216V33.33a.215.215 0 0 1 .216-.216h3.295a.216.216 0 0 1 .216.223l-.081 2.506a.108.108 0 0 0 .2.058l1.3-2.182z",
    transform: "translate(-707.475 -27.927)",
    style: {
      fill: "#080f13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29",
    d: "M416.625 38.74a1.587 1.587 0 0 1 1.586-1.586h2.939a.214.214 0 0 0 .214-.214v-2.979a.214.214 0 0 0-.184-.213 8.143 8.143 0 0 0-1.041-.058 3.611 3.611 0 0 0-1.344.252 1.482 1.482 0 0 0-.717.616l-1.376 2.3a.108.108 0 0 1-.2-.06l.112-2.762a.216.216 0 0 0-.216-.225h-3.293a.215.215 0 0 0-.216.216v11.939a.215.215 0 0 0 .216.216h3.3a.215.215 0 0 0 .216-.216V38.74z",
    transform: "translate(-350.894 -28.624)",
    style: {
      fill: "#080f13"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.95a1839f0e3688a26fbb2df845f42f2c.svg";
export { ForwardRef as ReactComponent };